import { PropMappingType } from "./type";
import { dashCase } from "../utils";
export function normalizePropToPropertyMapping(tagName, propName, propMapping) {
    return Object.assign(Object.assign({}, propMapping), { tagName,
        propName, property: Object.assign(Object.assign({}, propMapping.property), { name: propMapping.property.name || propName }), attribute: propMapping.attribute
            ? Object.assign(Object.assign({}, propMapping.attribute), { name: propMapping.attribute.name || dashCase(propName) }) : undefined });
}
const DEFAULT_OPTIONS = {
    description: "",
    attribute: true,
};
function asType(coerce, deserialize, options) {
    const opts = Object.assign(Object.assign({}, DEFAULT_OPTIONS), options);
    return {
        mappingType: PropMappingType.Property,
        property: {
            description: opts.description,
            coerce,
        },
        attribute: opts.attribute
            ? {
                deserialize,
            }
            : undefined,
    };
}
export const asNumber = (options) => asType(Number, parseFloat, options);
export const asString = (options) => asType(String, String, options);
export const asObject = (options) => asType(_ => _, JSON.parse, options);
